<template lang="pug">
    .post-heading
        h3.is-size-5(v-if="heading") {{ heading }}
</template>

<script>


export default {
    name: 'Heading',
    props: {
        heading: {
            type: String,
        },
        subHeading: {
            type: String,
        },
    },
}
</script>

<style lang="sass" scoped>

    @import '~@/assets/sass/variables';

    .content .post-heading
        h3
            margin-top: 6px
            color: red
            font-weight: 500
            margin-bottom: 0.8rem

</style>
